
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Isto é obra do proxecto
                    <a href="${0}">Folksonomía do Motor</a>. Non dubides
                    en participar ou dar a túa opinión.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Esta ferramenta permíteche corrixir a lista de ingredientes. Podes engadir, eliminar ou editar a
                lista de ingredientes.
                <br>
                Este carácter <span class="highlight">␣</span> representa un espazo.
                <br>
                Este carácter <span class="highlight">↩︎</span> representa un salto de liña. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Cargando propiedades...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Axúdanos cos ingredientes`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Validar cultivo`,
's03e9c8114521b998': `Vou editar os ingredientes`,
's05ec315d9308091a': `Icona de esquinas de código de barras`,
's061eb5af92512c85': `Gardado! Podes axudar con outro?`,
's06847c221c4c0bc1': `Gustaríame crear unha propiedade para [describir o teu caso de uso]...`,
's06f6c6f99db6b552': `Orixinal`,
's081e2ad82db71e1d': `Valores agrupados`,
's09205907b5b56cda': `Non`,
's0b4235aae602a950': `documentación dedicada`,
's0bb2d48532acc455': `Descargar CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Invalidar imaxe`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Cancelar recorte`,
's11a18a69b30b65ed': `Axúdanos a corrixir erros na lista de ingredientes`,
's1205d5f6fccf8e69': `Valor da propiedade`,
's15d64a0a6715285a': `Nova chave`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Área de selección`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Axúdanos a corrixir a información nutricional`,
's1e00019dc454872d': `Introduza un nome de propiedade usando o atributo property-name.`,
's1e49126af0935a5b': `Lista de produtos que usan esta propiedade`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancelar`,
's2db7b654c0a9bde0': `Documentar a propiedade`,
's300b3a6ee4e1252d': str`Coincidencia deficiente ${0}%`,
's33f786bb6b4f0cf4': `Resultado do recorte`,
's33f85f24c0f5f008': `Gardar`,
's34be4af4e8fec4ae': `Pregunta primeiro á comunidade`,
's36d86adc823cbfa6': `Antes de crear unha nova propiedade, fálao coa comunidade:`,
's3781d25aa51a736c': `Documentación do motor de folcsonomía`,
's383ae4449428b61e': `Restablecer recorte`,
's39bcf88721a1e8ee': `Restablecer selección`,
's39e14e14300694c7': `Documentación e directrices`,
's3b430cfa5c1fe7f4': str`Documentación para ${0}`,
's3f4e4b52f230a892': `Lenzo de imaxes`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Valor`,
's422bba9636ce2489': `Imaxe central`,
's42dd66b2441566fd': `Icona central`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Redimensionar á dereita`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Cargando...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Número de produtos`,
's4df2f533c0c1e7d0': `Controis de imaxe`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Mover selección`,
's4f751fb9b3ed766c': `Crear unha nova propiedade`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Introduza o nome da propiedade...`,
's55d7249883a98ca1': `sobre esta propiedade na wiki de Open Food Facts`,
's565867d84c04aea2': `Propiedades do filtro...`,
's5666afe5cd0166de': `Corrixe os erros ou modifica o texto antes de confirmar`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Cargando produtos...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Axúdanos a corrixir a información nutricional.`,
's5dd6f12783fca34f': `Editar a lista de ingredientes`,
's5e8250fb85d64c23': `Pechar`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Editar`,
's66413c24dcf680e2': `Saltar`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Imaxe recortada`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Boa coincidencia ${0}%`,
's71a5c9f4b68ef4d4': `Conta`,
's74cb3d66f6a668e1': `Documentación`,
's787dd11bed0dc88a': `Redimensionar á esquerda`,
's7ce4fd9430e80cea': `valor`,
's801a05fa8e881f37': `Máis información sobre a creación de propiedades e as directrices:`,
's8038273de2cf8b73': `Selecciona unha rexión para recortar.`,
's839cc2908a5387f2': `Filtrar códigos de barras...`,
's86197dcf3e96af64': `Explorar e buscar propiedades existentes`,
's8a63be30a129a59c': `Redimensionar a parte inferior`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Redimensionar arriba á dereita`,
's8db84aa4bc949af2': `Documentar a nova propiedade`,
's8f839a03997a16d7': `Ver produto`,
's901ae1e236ac45d3': `Cancelar eliminación`,
's907f7a97c6b29425': `Ten en conta que o modelo de datos pode ser modificado. Úsao baixo a túa propia responsabilidade.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredientes:`,
's9a7f60fce090ecaf': `Non se puideron cargar as propiedades. Téntao de novo máis tarde.`,
's9b87abd68fb9df45': `Non se atopou? Crear unha nova clave {value}`,
's9c0f52425fd2f07e': `Pode non coincidir`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Non hai puntuación dispoñible`,
'sa548778b24054030': `Explora todas as propiedades achegadas polo proxecto Folksonomy Engine. Estas propiedades proporcionan metadatos e información adicionais sobre os produtos da base de datos Open Food Facts.`,
'sa63907958bd0ec4b': `Redimensionar arriba á esquerda`,
'sa95b4224f685a36a': `Pechar modal`,
'sab56a1d439576fd6': `Icona de suxestión`,
'sac47ea2901d04c15': `Redimensionar a parte inferior esquerda`,
'sb125227d436c2925': `Busca o concepto da túa propiedade na base de datos de propiedades existente:`,
'sb125568d43642e6f': `Responder preguntas sobre o produto.`,
'sb1c538e038f9b214': str`Moi boa coincidencia ${0}%`,
'sb28639570ff3b852': `lista de todas as propiedades`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Unha vez que verifiques que a túa propiedade non existe e a comunidade está de acordo en que é útil, primeiro debes documentala na wiki.`,
'sb3d4f79d9d8b71e5': `Enviar`,
'sb560fa37a7bfb6c2': `Non se atoparon produtos para esta propiedade.`,
'sb7f72e4c8a2d3357': `Filtrar valores...`,
'sb8178320160f84ea': `Mostrar recorte`,
'sbad7d2734149470b': `Validar`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Todas as preguntas foron respondidas! Grazas pola túa axuda!`,
'sbd9a0b2293b3cd3c': `Tamaño da ración`,
'sbe472dc3c2685985': `Valor correspondente`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Redimensionar a parte superior`,
'sc1c08d0cbcc3bd24': `Non coincide`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Solución suxerida`,
'sc681b137e8f604f7': `Confirmar a eliminación`,
'sc6daf8a31883f8b9': `Mover imaxe`,
'sc895972c88d38ca5': `Propiedade de folcsonomía`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Filas`,
'scb3b0671d7b7f640': `Novo valor`,
'scb489a1a173ac3f0': `Si`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Únete á conversa de Slack`,
'scdb6cad0b92721bf': `Non se atoparon propiedades.`,
'scf23a05631f93732': `Confirmar eliminación`,
'scfed2f270ef6a3aa': `Seleccionar área`,
'sd1022bc1ef9204f7': `Imaxe con zoom`,
'sd1077c055cf9ba6b': `Axúdanos a validar a lista de ingredientes do produto.`,
'sd698d21ddecba56b': `Ola! Podes axudarnos a mellorar a información do produto respondendo ás seguintes partes:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Comprobar se xa existe unha propiedade`,
'sdbf806fefc584115': `Deberías atopar un/unha`,
'sdc673e73b5c13aea': `Eliminar`,
'sdc792b75f1edcaba': `Axúdanos a corrixir a ortografía dos ingredientes.`,
'sdca5deead576ceee': `Redimensionar a parte inferior dereita`,
'sdcc2555c5dde524f': `Seguro que queres eliminar este elemento? Esta acción non se pode desfacer.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Invalidar`,
'se5127cf0f92e7e48': `Consello: tamén podes atopar o`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Propoño unha colleita mellor`,
'seea3800e27baa686': `Produtos individuais`,
'sefaba4adc4ec9219': `Propiedades de folcsonomía`,
'seffa8ca49175b5f0': `Propiedades personalizadas`,
'sf44a6b3b232c28ea': str`Substituír o valor actual por ${0}`,
'sf4cd86a2f5ef2588': `Código de barras do produto`,
'sf57a61152168cc81': `Axúdanos a corrixir a detección de ingredientes`,
'sf88b90b8ba23871c': `Coincidencia descoñecida`,
'sf9aee319a006c9b4': `Engadir`,
'sfacbbe968fa7d773': `Nome da propiedade:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Valor correspondente`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  